// Dubai - personal trainer for seniors.
const content = {
    slug: 'personal-trainer-for-seniors',
    title: 'Personal Trainer for Seniors in Dubai | Strength & Balance at Home',
    description: (c) =>
        `Personal training for seniors in Dubai: safe strength, balance and mobility sessions at home. Packages from ${c.money(c.lowest, 0)} a session.`,
    eyebrow: 'Dubai · Seniors',
    h1: 'Personal Trainer for Seniors in Dubai',
    lead: 'Staying strong is what keeps people independent - climbing stairs, getting out of a low sofa, carrying shopping, travelling to see family. A trainer who specialises in older adults makes that work safe and steady, at home.',
    image: 'blog/health+and+fitness/elderly-fitness.webp',
    imageAlt: 'Older adult doing a supported strength exercise',
    facts: ['Fall prevention', 'Gentle progressions', 'Training at home, indoors'],
    ctaLabel: 'Request a trainer for a parent',
    matchSummary: 'a personal trainer for a senior in Dubai',
    packagesTitle: 'Packages for seniors',
    packagesIntro: 'Two sessions a week is a good rhythm for most older adults. Families often book on behalf of a parent.',
    sections: [
        {
            title: 'What sessions focus on',
            cards: [
                { title: 'Leg strength', body: 'Sit-to-stand, step-ups and supported squats - the basis of walking and climbing stairs safely.' },
                { title: 'Balance', body: 'Simple, supported drills that reduce the risk of falls, the biggest threat to independence.' },
                { title: 'Mobility', body: 'Shoulders, hips and back, so daily tasks and travel feel easier.' },
                { title: 'Confidence', body: 'Steady progress at a pace that feels safe, with someone watching every rep.' },
            ],
            cardColumns: 2,
        },
        {
            title: 'Safe training in the Dubai heat',
            tone: 'muted',
            paragraphs: [
                'Older adults are more sensitive to heat and dehydration. From May to September, sessions stay indoors in air-conditioned rooms, with water breaks built in. In the cooler months a gentle walk in the park or along the beach can join the routine.',
                'If your parent has a heart condition, diabetes, joint replacement or osteoporosis, share it when you book. The trainer will ask for their doctor\'s clearance and adapt every exercise.',
            ],
        },
    ],
    faqs: [
        {
            question: 'Is personal training safe for seniors?',
            answer: 'Yes, when it is adapted to the person. Trainers start with a health conversation and simple movement checks, and ask for a doctor\'s clearance where needed.',
        },
        {
            question: 'Can I book sessions for my parent who is visiting Dubai?',
            answer: 'Yes. Shorter packages (14 sessions) suit longer visits; mention the dates when you book.',
        },
        {
            question: 'Does my parent need any equipment?',
            answer: 'No. A sturdy chair and a bit of floor space are enough; the trainer brings light weights and bands.',
        },
    ],
    schema: { name: 'Personal Training for Seniors in Dubai' },
}

export default content
